import { i18n } from '../app';
import { CaseStatus } from '../static/enums/caseStatus';

export function getStatusText(status) {
  if (status === CaseStatus.OPEN) {
    return i18n.t('case.status.open');
  }

  if (status === CaseStatus.CLOSED) {
    return i18n.t('case.status.closed');
  }

  if (status === CaseStatus.ARCHIVED) {
    return i18n.t('case.status.archived');
  }

  if (status === CaseStatus.STOPPED) {
    return i18n.t('case.status.stopped');
  }

  if (status === CaseStatus.TARN) {
    return i18n.t('case.status.tarn');
  }

  if (status === CaseStatus.REJECTED) {
    return i18n.t('case.status.rejected');
  }

  if (status === CaseStatus.PARTIALLY_CLOSED) {
    return i18n.t('case.status.partially_closed');
  }

  if (status === CaseStatus.BEING_CLOSED) {
    return i18n.t('case.status.being_closed');
  }

  if (status === CaseStatus.BEING_PARTIALLY_CLOSED) {
    return i18n.t('case.status.being_partially_closed');
  }

  if (status === CaseStatus.BEING_REOPENED) {
    return i18n.t('case.status.being_reopened');
  }

  if (status === CaseStatus.BEING_STOPPED) {
    return i18n.t('case.status.being_stopped');
  }

  if (status === CaseStatus.BEING_UNSTOPPED) {
    return i18n.t('case.status.being_unstopped');
  }

  return '';
}
